export default __webpack_public_path__ + "static/media/404.08e21565.png";